import planificationEscl from '../locales/es-CL/planification.json';
import planificationEsmx from '../locales/es-MX/planification.json';
import planificationEsco from '../locales/es-CO/planification.json';
import planificationEnus from '../locales/en-US/planification.json';
import documentsEscl from '../locales/es-CL/documents.json';
import documentsEsmx from '../locales/es-MX/documents.json';
import documentsEsco from '../locales/es-CO/documents.json';
import documentsEnus from '../locales/en-US/documents.json';
import itemsEscl from '../locales/es-CL/items.json';
import itemsEsmx from '../locales/es-MX/items.json';
import itemsEsco from '../locales/es-CO/items.json';
import itemsEnus from '../locales/en-US/items.json';

import itemTableSchema from '../resources/itemTableSchema.json';
import documentTableSchema from '../resources/documentTableSchemaOp.json';
import badgeStylesPlanification from '../resources/badgeStylesPlanification.json';
import badgeStylesEditPlanification from '../resources/badgeStylesEditPlanification.json';
import badgeStylesOperation from '../resources/badgeStylesOperation.json';
import showConfirmation from '@waypoint/vue-confirmation';

import PlanificationService from '../services/PlanificationService';
import OperationService from '../services/OperationService';
import DocumentService from '../services/DocumentService';
import ItemService from '../services/ItemService';
import DriverService from '../services/DriverService';
import VehicleService from '../services/VehicleService';
import LogService from '../services/LogService';

import axios from 'axios';
import moment from 'moment';
import showAlert from '../alert/alertHandler';
import Container from 'typedi';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import Multiselect from 'vue-multiselect';
import inputSolver from '../planification/planificationBuilder/inputSolver.json';

import * as ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';

export default {
  name: 'planification',
  components: {
    Multiselect,
    VueCtkDateTimePicker,
  },
  i18n: {
    messages: {
      'es-CL': {
        planification: planificationEscl,
        documents: documentsEscl,
        items: itemsEscl,
      },
      'es-MX': {
        planification: planificationEsmx,
        documents: documentsEsmx,
        items: itemsEsmx,
      },
      'es-CO': {
        planification: planificationEsco,
        documents: documentsEsco,
        items: itemsEsco,
      },
      'en-US': {
        planification: planificationEnus,
        documents: documentsEnus,
        items: itemsEnus,
      },
    },
  },
  data() {
    return {
      filterKeyword: '',
      dataAccess: null,
      isMainPageBussy: false,
      isFilterBussy: false,
      isFilterShown: false,
      isFilterClicked: false,
      isFilterApplied: false,
      isBussyCreateMode: false,
      haveResources: null,
      totalPlanificationRows: 0,
      totalOperationRows: 0,
      currentPage: 1,
      currentPageRoutes: 1,
      currentPageOperations: 1,
      currentPageDocuments: 1,
      currentPageItems: 1,
      perPage: 10,
      perPageRoutes: 10,
      perPageOperations: 10,
      perPageDocuments: 10,
      perPageItems: 10,
      pageOptions: [10, 15, 20, 50, 100],
      filters: {
        planificationName: null,
        executionDate: null,
        startDate: null,
        endDate: null,
        driver: null,
        vehicle: null,
        planificationState: null,
        routeState: null,
        origin: null,
        destination: null,
        planificationId: null,
      },
      planificationFilter: [],
      editMode: false,
      planifications: [],
      routes: [],
      operations: [],
      documents: [],
      items: [],
      drivers: [],
      vehicles: [],
      itemTypeData: [],
      itemData: [],
      optionSpots: [],
      currentTab: 'planificaciones',
      selectedPlanification: null,
      selectedRoute: null,
      selectedOperation: null,
      selectedDocument: null,
      selectedItem: null,
      badges: badgeStylesPlanification,
      editBadges: badgeStylesEditPlanification,
      badgesOperation: badgeStylesOperation,
      planificationService: null,
      operationService: null,
      itemService: null,
      documentService: null,
      driverService: null,
      vehicleService: null,
      logService: null,
      routeSelectedEnd: null,
      temporalCommentEndRoute: null,
      states: ['NOTENDED', 'STARTED', 'ONGOING', 'ENDED', 'CANCELED'],
      editStates: ['NOTENDED', 'STARTED', 'ENDED'],
      operationSelected: null,
    };
  },
  async created() {
    this.planificationService = Container.get(PlanificationService);
    this.operationService = Container.get(OperationService);
    this.documentService = Container.get(DocumentService);
    this.itemService = Container.get(ItemService);
    this.driverService = Container.get(DriverService);
    this.vehicleService = Container.get(VehicleService);
    this.logService = Container.get(LogService);
    this.prepareData();
  },
  methods: {
    async showToast(actionStart, actionEnd, routePlan, newStateTemp) {
      const h = this.$createElement;
      const id = `my-toast-driver-busy-warning`;

      const $closeButton = h(
        'b-button',
        {
          on: {
            click: async () => {
              await this.$bvToast.hide(id);
            },
          },
        },
        this.$t('common.botones.cancelar'),
      );
      const $acceptButton =
        actionStart === false && actionEnd === false
          ? h()
          : h(
              'b-button',
              {
                class: ['float-right'],
                props: { variant: 'success' },
                on: {
                  click: async () => {
                    if (actionStart && !actionEnd) {
                      await this.editStartRoute(routePlan, true);
                      this.refreshEditTables();
                    }
                    if (!actionStart && actionEnd) {
                      await this.editEndRoute(routePlan, true);
                      this.refreshEditTables();
                    }
                    if (actionStart && actionEnd) {
                      await this.editStartRoute(routePlan, false);
                      await this.editEndRoute(routePlan, true);
                      this.refreshEditTables();
                    }
                    await this.$bvToast.hide(id);
                  },
                },
              },
              this.$t('common.botones.aceptar'),
            );
      let $vNodesMsg = h('p', { class: ['text-left', 'y-16'] }, [
        actionStart === false && actionEnd === false
          ? this.$t('planification.table.planification.cantEditRoute', {
              routeName: routePlan.name,
              lastState: this.$t('planification.states.planificationEdit.' + routePlan.state),
              newState: this.$t('planification.states.planificationEdit.' + newStateTemp),
            })
          : this.$t('planification.table.planification.askEditRoute', {
              routeName: routePlan.name,
              lastState: this.$t('planification.states.planificationEdit.' + routePlan.state),
              newState: this.$t('planification.states.planificationEdit.' + newStateTemp),
            }),
      ]);
      const $vNodesTitle = h('div', { class: ['d-flex', 'flex-grow-1', 'align-items-baseline', 'mr-2'] }, [
        h('strong', { class: 'mr-2-xl' }, 'Confirmación'),
      ]);

      this.$bvToast.toast([$vNodesMsg, $closeButton, $acceptButton], {
        id: id,
        title: [$vNodesTitle],
        variant: 'alert',
        toaster: 'b-toaster-top-center',
        noCloseButton: actionStart === false && actionEnd === false ? false : true,
        static: true,
        noAutoHide: true,
        solid: true,
      });
    },
    async editStateRoute(newState, routePlan) {
      console.log(routePlan);
      if (routePlan.state === 'NOTENDED') {
        if (newState === 'ENDED') {
          this.showToast(true, true, routePlan, newState);
          console.log('NOTIFICO');
        } else if (newState === 'STARTED') {
          this.showToast(true, false, routePlan, newState);
          console.log('NOTIFICO');
        } else {
          this.showToast(false, false, routePlan, newState);
        }
      }
      if (routePlan.state === 'STARTED') {
        if (newState === 'ENDED') {
          this.showToast(false, true, routePlan, newState);
          console.log('NOTIFICO');
        } else {
          this.showToast(false, false, routePlan, newState);
        }
      }
    },
    async notifyRouteModified(routePlan) {
      const url = `${this.$store.getters.urlAPI}/routeplan/requestRouteModified`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        await axios.post(
          url,
          {
            idDriver: routePlan.resources[0].idDriver,
            idRoute: routePlan.id,
            routeName: routePlan.name,
          },
          config,
        );
      } catch (e) {
        this.logService.sendError({
          component: 'planification',
          message: `notifyRouteModified fallo ${e.message}`,
        });
        showAlert('Error', e.response.data);
      }
    },
    refreshEditTables() {
      this.currentTab = 'planificaciones';
      this.handlePageChangeOperations();
    },
    async editStartRoute(routePlan, last) {
      const now = new Date().getTime();
      const body = {
        source: 1,
        sourceDate: now,
        createDate: now,
        lat: null,
        lon: null,
        statusCreatedAt: now,
      };
      const url = `${this.$store.getters.urlAPI}/routeplan/${routePlan.id}/driver/${routePlan.resources[0].idDriver}/start`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        await axios.post(url, body, config);
        if (last) {
          this.notifyRouteModified(routePlan);
          showAlert(
            this.$t('planification.alertMessages.success.title'),
            this.$t('planification.alertMessages.success.message'),
          );
        }
      } catch (e) {
        this.logService.sendError({
          component: 'planification',
          message: `editStartRoute fallo ${e.message}`,
        });
        showAlert('Error', e.response.data);
      }
    },
    async editEndRoute(routePlan, last) {
      const now = new Date().getTime();
      const body = {
        source: 1,
        sourceDate: now,
        createDate: now,
        lat: null,
        lon: null,
        statusCreatedAt: now,
      };
      const url = `${this.$store.getters.urlAPI}/routeplan/${routePlan.id}/driver/${routePlan.resources[0].idDriver}/end`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        await axios.post(url, body, config);
        if (last) {
          this.notifyRouteModified(routePlan);
          showAlert(
            this.$t('planification.alertMessages.success.title'),
            this.$t('planification.alertMessages.success.message'),
          );
        }
      } catch (e) {
        this.logService.sendError({
          component: 'planification',
          message: `editEndRoute fallo ${e.message}`,
        });
        showAlert('Error', e.response.data);
      }
    },
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
    },
    async getDestinations() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/spot/simple`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.optionSpots = response.data.data;
        this.setDestinationsAddressStreet();
      } catch (e) {
        this.logService.sendError({
          component: 'planification',
          message: `getDestinations fallo ${e.message}`,
        });
        this.optionSpots = [];
      }
    },
    /**
     * Metodo que obtiene la calle de los destinos.
     */
    setDestinationsAddressStreet() {
      this.optionSpots.forEach((destination) => {
        destination.addressStreet = destination.address.street;
      });
    },
    editPlanification(planification) {
      this.$router.push({
        name: 'OperationProcess',
        params: { planificationId: planification.id.toString(), planificationState: planification.state },
      });
    },
    confirmDelete(planification) {
      showConfirmation(
        this.$t('common.modals.confirmacionTitulo'),
        this.$t('planification.crud.confirmDelete', { name: planification.planificationName }),
        () => {
          this.deletePlanification(planification);
        },
        this.$t('common.cruds.aceptar'),
        this.$t('common.cruds.cerrar'),
      );
    },
    sendInfoRoute(route) {
      this.routeSelectedEnd = route;
    },
    async deletePlanification(planification) {
      try {
        const response = await axios.delete(`${this.$store.getters.urlAPI}/planification/${planification.id}`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        if (response.data.status) {
          this.currentTab = 'planificaciones';
          await this.handlePageChange();
          showConfirmation(
            this.$t('common.modals.confirmacionTitulo'),
            'Su planificacion ha sido eliminada exitosamente',
            () => {
              return;
            },
            this.$t('common.cruds.aceptar'),
            this.$t('common.cruds.cerrar'),
          );
        }
      } catch (e) {
        this.logService.sendError({
          component: 'planification',
          message: `deletePlanification fallo ${planification.id} ${e.message}`,
        });
        showConfirmation(
          this.$t('common.modals.confirmacionTitulo'),
          'No se pudo eliminar la planificación, error: ' + e,
          this.$t('common.cruds.aceptar'),
          this.$t('common.cruds.cerrar'),
        );
      }
    },
    async sendToCreateMode() {
      this.logService.sendInfo({
        component: 'planification',
        message: 'sendToCreateMode',
      });
      this.isBussyCreateMode = true;
      const haveResources = await this.getClientResources();
      if (haveResources.driversAvailable && haveResources.vehiclesAvailable) {
        this.isBussyCreateMode = false;
        //return await this.callTest();
        return this.$router.push({ name: 'OperationProcessNotOngoing' });
      } else {
        this.haveResources = haveResources;
        this.showModal('client-have-resources');
      }
      this.isBussyCreateMode = false;
    },
    async callTest() {
      const inputOptimization = inputSolver;
      let form = {};
      form.planificationName = inputOptimization.name;
      form.executionDate = moment(new Date(inputOptimization.startDate)).format('YYYY-MM-DD');
      form.initHour = moment(new Date(inputOptimization.startDate)).format('HH:mm:ss');
      form.endHour = moment(new Date(inputOptimization.endDate)).format('HH:mm:ss');
      let tags = await this.getTags();
      let senderList = await this.getSenderList();
      const optionSpots = await this.getDestinationsForTest();
      const typeOperationOptions = [
        {
          type: 'DELIVERY',
          name: 'Entrega',
        },
        {
          type: 'COLLECTION',
          name: 'Retiro',
        },
      ];
      const trafficFactorOptions = [
        // 1.01 para que no sea automático
        { factor: 1, name: this.$t('planification.solver.trafficFactor.dinamic') },
        { factor: 1.01, name: this.$t('planification.solver.trafficFactor.low') },
        { factor: 1.5, name: this.$t('planification.solver.trafficFactor.medium') },
        { factor: 2, name: this.$t('planification.solver.trafficFactor.high') },
        { factor: 3, name: this.$t('planification.solver.trafficFactor.veryhigh') },
      ];
      //Si  rellena las variables globales de depot de inicio
      let depotStart = inputOptimization.depots[0];
      const depotOrigin = optionSpots.find((spot) => spot.id === depotStart.extraInfo.id);

      let depotDestination = null;
      //Si posee depot de destino rellena las variables globales de depot de destino
      if (inputOptimization.depots.length > 1) {
        let depotEnd = inputOptimization.depots[1];
        depotDestination = optionSpots.find((spot) => spot.id === depotEnd.extraInfo.id);
      }
      let checkedVehicles = [];
      let checkedDrivers = [];
      let checkedGeoFences = [];
      inputOptimization.resources.forEach((resource) => {
        checkedVehicles.push(resource.extraInfo.vehicle.id);
        checkedDrivers.push(resource.extraInfo.driver.id);
        if (resource.geofences) {
          //resource.geofences es un listado de ids de geocercas
          checkedGeoFences.push({
            id: resource.extraInfo.vehicle.id,
            geofences: resource.geofences,
          });
        }
      });
      let trafficFactor = {};
      let useGeoFence = false;
      let useAllFleet = false;

      trafficFactor = trafficFactorOptions.find((tf) => tf.factor == 1.01);
      if (inputOptimization.parameters && inputOptimization.parameters.trafficFactor) {
        const factorObject = trafficFactorOptions.find((tf) => tf.factor == inputOptimization.parameters.trafficFactor);
        if (factorObject) {
          trafficFactor = factorObject;
        }
      }
      if (inputOptimization.parameters && inputOptimization.parameters.useGeofences) {
        useGeoFence = inputOptimization.parameters.useGeofences;
      }
      if (inputOptimization.parameters && inputOptimization.parameters.useAllFleet) {
        useAllFleet = inputOptimization.parameters.useAllFleet;
      }
      let operations = [];
      let spotsTemporalData = [];
      inputOptimization.operations.forEach((operation) => {
        let spot = inputOptimization.spots.find((spot) => spot.name == operation.spot);
        let tags = null;
        const auxAddress = this.buildBodySpotEditMode(spot, spotsTemporalData);
        let body = {
          idOperationJob: this.idOperationJob++,
          uuid: operation.uuid,
          idSpotTemporal: operation.idSpotTemporal,
          name: operation.name,
          tags: tags,
          address: auxAddress.address,
          addressComplement: auxAddress.addressComplement,
          neighborhood: auxAddress.neighborhood,
          city: auxAddress.city,
          state: auxAddress.state,
          country: auxAddress.country,
          typeOperation: typeOperationOptions.find((operationType) => operationType.type == operation.type),
          lat: spot ? spot.lat : null,
          lon: spot ? spot.lon : null,
          operationState: 'NOTHANDLED',
          geocodingResult: operation.extraInfo.geocodingResult,
          startHour:
            operation.spotTimeWindow && operation.spotTimeWindow.startTime
              ? moment(new Date(operation.spotTimeWindow.startTime)).format('HH:mm')
              : null,
          endHour:
            operation.spotTimeWindow && operation.spotTimeWindow.endTime
              ? moment(new Date(operation.spotTimeWindow.endTime)).format('HH:mm')
              : null,
          spotServiceTime: operation.spotServiceTime ? operation.spotServiceTime / 60 : 10,
          contact: operation.extraInfo.customerName ? operation.extraInfo.customerName : null,
          phone: operation.extraInfo.customerPhone ? operation.extraInfo.customerPhone : null,
          email: operation.extraInfo.customerEmail ? operation.extraInfo.customerEmail : null,
          idSender: operation.extraInfo.idSender ? operation.extraInfo.idSender : null,
          sender: null,
          documents: operation.extraInfo.documents ? operation.extraInfo.documents : [],
          volume: operation.volume,
          weight: operation.weight,
          money: operation.money,
        };
        if (body.idSender) {
          for (let index in senderList) {
            if (body.idSender == senderList[index].id) {
              body.sender = senderList[index];
            }
          }
        }
        operations.push(body);
      });
      this.$store.commit('setMetaData', {
        operations: operations,
        tags: tags,
        spotsTemporalData: spotsTemporalData,
        form: form,
        depotOrigin: depotOrigin,
        depotDestination: depotDestination,
        trafficFactor: trafficFactor,
        useGeoFence: useGeoFence,
        useAllFleet: useAllFleet,
      });
      return this.$router.push({ name: 'ResourceProcessNotOngoing' });
    },
    async getDestinationsForTest() {
      try {
        const response = await axios.get(`${this.$store.getters.urlAPI}/api/spot`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        return response.data.data;
      } catch (e) {
        this.logService.sendError({
          component: 'planificationBUilder',
          message: `getdestinations fallo el obtener los destinos ${e.message}`,
        });
        return [];
      }
    },
    async getSenderList() {
      try {
        const url = `${this.$store.getters.urlAPI}/sender?pageNum=1&pageSize=200`;
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        return response.data.data;
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getSenderList fallo el obtener los senders ${e.message}`,
        });
        if (e.response.status === 404) {
          return [];
        }
        return;
      }
    },
    async getTags() {
      try {
        this.logService.sendInfo({
          component: 'operationProcess',
          message: `getTags llamada a la api de lastmile`,
        });
        this.isLoadingTag = true;
        const response = await axios.get(`${this.$store.getters.urlAPI}/tag`, {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        });
        this.isLoadingTag = false;
        if (response.data.status) {
          return response.data.data;
        }
        return [];
      } catch (e) {
        this.logService.sendError({
          component: 'operationProcess',
          message: `getTags fallo ${e.message}`,
        });
        this.isLoadingTag = false;
        console.log(e);
        return [];
      }
    },
    findStatusOperation(operation, opsWithStatus) {
      const status = 'NOTHANDLED';
      for (const opWStatus of opsWithStatus) {
        if (operation.uuid === opWStatus.uuid && opWStatus.state !== 'NEW') {
          return opWStatus.state;
        }
      }
      return status;
    },
    findOperationResource(routes, currentOperation) {
      for (let i = 0; i < routes.length; i++) {
        const route = routes[i];
        const resource = route.resources[0];

        // Verifica si la operación actual está dentro del listado de operaciones
        if (
          resource.operations.some(
            (operation) =>
              (operation.task === 'DELIVERY' || operation.task === 'COLLECTION') &&
              operation.uuid === currentOperation.uuid,
          )
        ) {
          // Retorna un objeto con extraInfo y el índice de la ruta
          return { resource: resource.extraInfo, route: `Ruta ${i + 1}` };
        }
      }

      // Si no se encuentra la operación, retorna null o un valor predeterminado
      return null;
    },
    buildBodySpotEditMode(spot, spotsTemporalData) {
      //Se prepara el body de una operación
      let auxAddress = {};
      // Validacion para saber si tiene el nuevo campo de vecindario o complemento
      if (spot.extraInfo.addressComplete) {
        auxAddress = JSON.parse(spot.extraInfo.addressComplete);
      } else {
        let address = spot ? spot.extraInfo.address.split(',') : null;
        if (spot && ('hasAddressComp' in spot.extraInfo || 'hasNeighborhood' in spot.extraInfo)) {
          let hasAddressComp = spot.extraInfo.hasAddressComp;
          let hasNeighborhood = spot.extraInfo.hasNeighborhood;

          let neighborhood = null;
          let addressComplement = null;

          let lastIndex = 0;
          if (address.length == 5) {
            if (hasAddressComp) addressComplement = address ? address[1] : null;
            if (hasNeighborhood) neighborhood = address ? address[1] : null;
            lastIndex = 1;
          } else if (address.length > 5) {
            addressComplement = address ? address[1] : null;
            neighborhood = address ? address[2] : null;
            lastIndex = 2;
          }

          auxAddress = {
            address: address ? address[0] : null,
            addressComplement: addressComplement,
            neighborhood: neighborhood,
            city: address ? address[++lastIndex] : null,
            state: address ? address[++lastIndex] : null,
            country: address ? address[++lastIndex] : null,
          };
        } else {
          auxAddress = {
            address: address ? address[0] : null,
            addressComplement: address && address.length == 5 ? address[1] : null,
            neighborhood: null,
            city: address ? (address.length == 4 ? address[1] : address[2]) : null,
            state: address ? (address.length == 4 ? address[2] : address[3]) : null,
            country: address ? (address.length == 4 ? address[3] : address[4]) : null,
          };
        }
      }
      //Se prepara el body de los spots
      let spotBody = {
        id: spot.extraInfo.id,
        address: {
          lat: spot.lat,
          lon: spot.lon,
          addressComplement: auxAddress.addressComplement,
          neighborhood: auxAddress.neighborhood,
          street: auxAddress.address,
          city: auxAddress.city,
          state: auxAddress.state,
          country: {
            name: auxAddress.country,
          },
        },
      };
      spotsTemporalData.push(spotBody);
      return auxAddress;
    },
    goToAnotherPage(newPath) {
      return this.$router.push({ path: newPath });
    },
    async getClientResources() {
      this.logService.sendInfo({
        component: 'planification',
        message: 'getClientResources obteniendo recursos del cliente',
      });
      const urlCheckClientResource = `${this.$store.getters.urlAPI}/planification/checkClientResource`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(urlCheckClientResource, config);
        const haveResources = response.data.data;
        return haveResources;
      } catch (e) {
        this.logService.sendInfo({
          component: 'planification',
          message: 'Error obteniendo planification/checkClientResource al obtener recursos del cliente: ' + e.message,
        });
        console.log(e);
      }
    },
    cleanFilter() {
      this.filters.planificationName = null;
      this.filters.executionDate = null;
      this.filters.startDate = null;
      this.filters.endDate = null;
      this.filters.driver = null;
      this.filters.vehicle = null;
      this.filters.planificationState = null;
      this.filters.routeState = null;
      this.filters.origin = null;
      this.filters.destination = null;
      this.filters.planificationId = null;
      this.filter();
    },
    async loadPlanifications() {
      try {
        this.logService.sendInfo({
          component: 'planification',
          message: 'loadPlanifications cargando las planificaciones y construyendo el objeto para el front',
        });
        const filters = this.retrieveFilterData();
        const data = await this.planificationService.getPlanifications(this.currentPage, this.perPage, filters);
        this.planifications = data.data;
        //Ordenar de planificación mas recientes a la mas antigua
        this.planifications = this.planifications.sort((a, b) => {
          return new Date(b.executionDate).getTime() - new Date(a.executionDate).getTime();
        });
        this.planifications.forEach((plan) => {
          const exeDateTemp = new Date(plan.executionDate);
          const execSeconds = exeDateTemp.getTime();
          plan.executionDateFilter = moment(execSeconds).format('YYYY-MM-DD');
          plan.enabledEdit =
            plan.state === 'NOTENDED' || plan.state === 'STARTED' || plan.state === 'ONGOING' ? true : false;
          plan.enabledDelete = plan.state === 'NOTENDED' ? true : false;
          plan.userNameModified = `${plan.userLastModifiedfFrstName} ${plan.userLastModifiedLastName}`;
        });
        this.totalPlanificationRows = data.paginator ? data.paginator.totalRows : 0;
      } catch (e) {
        this.logService.sendError({
          component: 'planification',
          message: 'loadPlanifications fallo por el siguiente motivo ' + e.message,
        });
        console.log(e);
        return [];
      }
    },
    loadRoutes() {
      const planification = this.planifications.find((plan) => plan.id === this.selectedPlanification);
      this.routes = planification && planification.routesPlan ? planification.routesPlan : [];
    },
    async loadOperations() {
      const route = this.routes.find((route) => route.id === this.selectedRoute);
      const vehicle = route && route.resources ? route.resources[0].vehicle : null;
      const filters = {
        idRoute: this.selectedRoute,
        vehicle: vehicle,
      };
      const data = await this.operationService.getOperations(
        this.currentPageOperations,
        this.perPageOperations,
        filters,
      );
      this.operations = data.data || [];
      this.totalOperationRows = data.paginator ? data.paginator.totalRows : 0;
    },
    async loadDocuments() {
      this.documents = await this.documentService.getDocumentsByIdOperation(this.selectedOperation);
    },
    async loadItemsDetails() {
      this.items = await this.itemService.getItemsByIdDocumentOp(this.selectedDocument);
    },
    async sendToAdministrationMode() {
      this.isMainPageBussy = true;
      this.isFilterBussy = true;
      this.editMode = true;
      await this.loadPlanifications();
      this.isMainPageBussy = false;
      this.getDestinations();
      this.getVehicles();
      this.getDrivers();
      this.isFilterBussy = false;
      const itemData = await this.itemService.getItems();
      this.itemTypeData = await this.itemService.getTypes();
      this.itemData = itemData;
    },
    /**
     * Funciones para desactivar el filtro clickeando fuera de la pantalla
     */
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    retrieveFilterData() {
      this.logService.sendInfo({
        component: 'planification',
        message: 'retrieveFilterData preparando los filtros a realizar para consultar a la api',
      });
      //Se prepara el link.
      const filters = {};
      this.isFilterApplied = false;
      //Se verifica cada filtro, si el filtro de aplica: se agrega al link.
      if (this.filters.startDate) {
        const dateFrom = new Date(this.filters.startDate);
        const secondsFrom = dateFrom.getTime();
        filters.startDate = secondsFrom;
      }
      if (this.filters.endDate) {
        const dateUntil = new Date(this.filters.endDate);
        const secondsUntil = dateUntil.getTime();
        filters.endDate = secondsUntil;
      }
      if (this.filters.origin) {
        filters.idOrigin = this.filters.origin;
      }
      if (this.filters.destination) {
        filters.idDestination = this.filters.destination;
      }
      if (this.filters.planificationState && this.filters.planificationState.length > 0) {
        filters.planificationState = this.filters.planificationState;
      }
      if (this.filters.routeState && this.filters.routeState.length > 0) {
        filters.routeState = this.filters.routeState;
      }
      if (this.filters.planificationName) {
        filters.planificationName = this.filters.planificationName;
      }
      if (this.filters.planificationId) {
        filters.planificationId = this.filters.planificationId;
      }
      if (this.filters.driver && this.filters.driver.length > 0) {
        filters.driver = this.filters.driver;
      }
      if (this.filters.vehicle && this.filters.vehicle.length > 0) {
        filters.vehicle = this.filters.vehicle;
      }

      this.isFilterApplied = Object.keys(filters).length > 0;
      console.log('filtros enviados', filters);
      return filters;
    },
    /* metodos de carga de datos complementarios */
    async getDrivers() {
      const includeOnlyUsers = false;
      const drivers = await this.driverService.getDrivers(includeOnlyUsers);
      this.drivers = drivers;
      this.drivers.forEach((driver) => {
        driver.fullName = this.transformWords(driver.firstName) + '  ' + this.transformWords(driver.lastName);
      });
    },
    async endRoute() {
      const now = new Date().getTime();
      const body = {
        source: 1,
        sourceDate: now,
        createDate: now,
        lat: null,
        lon: null,
        statusCreatedAt: now,
      };
      const url = `${this.$store.getters.urlAPI}/routeplan/${this.routeSelectedEnd.id}/driver/${this.routeSelectedEnd.resources[0].idDriver}/end`;
      const config = {
        headers: {
          'id-client': this.$store.getters.clientId,
          Authorization: `Bearer ${this.$store.getters.accessToken}`,
        },
      };
      try {
        await axios.post(url, body, config);
        showAlert(
          this.$t('planification.alertMessages.success.title'),
          this.$t('planification.alertMessages.success.message'),
        );
        this.currentTab = 'planificaciones';
        this.handlePageChange();
      } catch (e) {
        showAlert('Error', e.response.data);
      }
    },
    limitText(count) {
      return this.$t('planification.search.limitText') + (count + 1);
    },
    async getVehicles() {
      const vehicles = await this.vehicleService.getVehicles();
      this.vehicles = vehicles;
    },
    filter() {
      this.activeFilter();
      this.currentTab = 'planificaciones';
      this.handlePageChange();
    },
    handlePageChangeOperations() {
      this.operations = [];
      this.selectedDocument = null;
      this.selectedItem = null;
      this.loadByTab(this.currentTab);
    },
    async handlePageChange() {
      this.planifications = [];
      this.selectedPlanification = null;
      this.selectedRoute = null;
      this.selectedOperation = null;
      this.selectedDocument = null;
      this.selectedItem = null;
      this.loadByTab(this.currentTab);
    },
    async loadByTab(navBar) {
      this.isMainPageBussy = true;
      if (navBar === 'planificaciones') {
        await this.loadPlanifications();
      } else if (navBar === 'rutas') {
        await this.loadRoutes();
      } else if (navBar === 'operaciones') {
        await this.loadOperations();
      } else if (navBar === 'documentos') {
        await this.loadDocuments();
      } else if (navBar === 'items') {
        await this.loadItemsDetails();
      }
      this.isMainPageBussy = false;
    },
    changeTab(navBar) {
      const ranking = ['planificaciones', 'rutas', 'operaciones', 'documentos', 'items'];
      const previousTabIndex = ranking.indexOf(this.currentTab);
      this.currentTab = navBar;
      const currentTabIndex = ranking.indexOf(this.currentTab);
      if (currentTabIndex > previousTabIndex) {
        this.loadByTab(navBar);
      }
    },
    onPlanificationClicked(item, index, event) {
      this.selectedRoute = null;
      this.selectedOperation = null;
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedPlanification = item.id;
      this.currentPageTrip = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('rutas');
      }
    },
    onRouteClicked(item, index, event) {
      this.selectedOperation = null;
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedRoute = item.id;
      this.currentPageActivity = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('operaciones');
      }
    },
    onOperationClicked(item, index, event) {
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedOperation = item.id;
      this.currentPageDocument = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('documentos');
      }
    },
    onDocumentClicked(item, index, event) {
      this.selectedItem = null;
      this.selectedDocument = item.id;
      this.currentPageItem = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('items');
      }
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let listWords = words.split(' ');
      let finalWord = '';
      listWords.forEach((word) => {
        if (word) {
          if (finalWord == '') {
            finalWord = this.capitalize(word);
          } else {
            finalWord = finalWord + ' ' + this.capitalize(word);
          }
        }
      });
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    /* metodos de procesamiento de datos para renderizado */
    getTypeItem(id) {
      for (let itemDataObj of this.itemData) {
        if (id === itemDataObj.id) {
          return this.getDescTypeItem(itemDataObj.idItem);
        }
      }
      return '-';
    },
    getDescTypeItem(id) {
      for (let itemType of this.itemTypeData) {
        if (id === itemType.id) {
          return itemType.name;
        }
      }
      return '-';
    },
    getCodeItem(id) {
      for (let itemDataObj of this.itemData) {
        if (id === itemDataObj.id) {
          return itemDataObj.code;
        }
      }
      return '-';
    },
    async excelDepot(planification) {
      const url = `${this.$store.getters.urlAPI}/planification/${planification.id.toString()}`;

      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const response = await axios.get(url, config);
        const planification = response.data.data;
        this.optimizationResult = JSON.parse(planification.outputOptimization);
        console.log(this.itemTypeData);
        console.log('output ', this.optimizationResult);
        this.buildExcelPro();
      } catch (e) {
        console.log(e);
      }
    },
    async buildExcelPro() {
      console.log('PRO PRO PRO');
      console.log(this.tags);
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet('Operaciones');

      const headers = [
        { header: 'Vehículo', key: 'veh', width: 40 },
        { header: 'Operador', key: 'dri', width: 40 },
        { header: 'Operación ', key: 'ope', width: 30 },
        { header: 'Nro. Documento', key: 'nro', width: 20 },
        { header: 'Item', key: 'ite', width: 20 },
        { header: 'Codigo Item', key: 'cod', width: 20 },
        { header: 'Tipo de Item', key: 'tip', width: 40 },
        { header: 'Unidad', key: 'uni', width: 20 },
        { header: 'Cantidad Planificada', key: 'cpl', width: 20 },
      ];

      ws.columns = headers;

      this.optimizationResult.routes.forEach((route) => {
        route.resources[0].operations.forEach((op) => {
          if (op.uuid) {
            if (op.extraInfo.documents.length > 0) {
              op.extraInfo.documents.forEach((docs) => {
                docs.items.forEach((item) => {
                  this.itemTypeData.forEach((itemData) => {
                    if (item.idItem === itemData.id) {
                      item['unit'] = itemData.unit;
                      item['type'] = itemData.name;
                    }
                  });
                  ws.addRow({
                    veh: route.resources[0].extraInfo.vehicle.plate,
                    dri: route.resources[0].extraInfo.driver.driverName,
                    ope: op.name,
                    nro: docs.number,
                    ite: item.name,
                    cod: item.code,
                    tip: item.type,
                    uni: item.unit,
                    cpl: item.quantity,
                  });
                });
              });
            } else {
              ws.addRow({
                dri: route.resources[0].extraInfo.driver.driverName,
                veh: route.resources[0].extraInfo.vehicle.plate,
                ope: op.name,
                nro: '',
                tip: '',
                ite: '',
                uni: '',
                cpl: '',
                cod: '',
              });
            }
          }
        });
      });

      const buffer = await wb.xlsx.writeBuffer();
      const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
      const fileExtension = '.xlsx';
      const blob = new Blob([buffer], { type: fileType });
      saveAs(blob, 'Planificación ' + this.optimizationResult.name + fileExtension);
    },
    closeModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
  },
  computed: {
    filtered() {
      if (this.filterKeyword) {
        return this.planificationItems.filter((item) => {
          if (item.name && item.name.toUpperCase().includes(this.filterKeyword.toUpperCase())) {
            return item;
          }
          if (item.name && item.name.toUpperCase().includes(this.filterKeyword.toUpperCase())) {
            return item;
          }
        });
      } else {
        return this.planificationItems;
      }
    },
    /* indicadores de tabla habilitada */
    isRouteTabEnabled() {
      return !!this.selectedPlanification;
    },
    isOperationTabEnabled() {
      return !!this.selectedPlanification && !!this.selectedRoute;
    },
    isDocumentTabEnabled() {
      return !!this.selectedPlanification && !!this.selectedRoute && !!this.selectedOperation;
    },
    isItemTabEnabled() {
      return (
        !!this.selectedPlanification && !!this.selectedRoute && !!this.selectedOperation && !!this.selectedDocument
      );
    },
    stateItems() {
      return this.states.map((s) => {
        return {
          id: s,
          name: this.$t(`planification.states.planification.${s}`),
        };
      });
    },
    planificationItems() {
      return this.planifications.map((p) => {
        const reacheableOperations = p.totalReachableOperations ? p.totalReachableOperations : p.totalOperations;
        const executionDate = moment(new Date(p.executionDate).getTime()).format('DD/MM/YY HH:mm');
        const modifiedAt = moment(new Date(p.modifiedAt).getTime()).format('DD/MM/YY');
        return {
          ...p,
          executionDate: executionDate,
          modifiedAt: modifiedAt,
          totalOperationsOptimized: `${reacheableOperations}/${p.totalOperations}`,
        };
      });
    },
    routeItems() {
      return this.routes.map((r) => {
        let isFilteredRoute = false;
        const startDate = r.resources[0] ? moment(r.resources[0].startDate).format('DD/MM - HH:mm [hrs.]') : '-';
        const endDate = r.resources[0] ? moment(r.resources[0].endDate).format('DD/MM - HH:mm [hrs.]') : '-';

        if (this.filters.driver && this.filters.driver.length > 0) {
          isFilteredRoute = this.filters.driver.some((driver) => r.resources[0].idDriver == driver.id) ? true : false;
        }
        if (!isFilteredRoute && this.filters.vehicle && this.filters.vehicle.length > 0) {
          isFilteredRoute = this.filters.vehicle.some((vehicle) => r.resources[0].idVehicle == vehicle.id)
            ? true
            : false;
        }
        return {
          ...r,
          driver: r.resources[0] ? r.resources[0].driverName : '-',
          vehicle: r.resources[0] ? r.resources[0].plate : '-',
          origin: r.resources[0]
            ? `${r.resources[0].origin.address.street}, ${r.resources[0].origin.address.state}`
            : '-',
          destination: r.resources[0]
            ? `${r.resources[0].destination.address.street}, ${r.resources[0].destination.address.state}`
            : '-',
          executionDate: `${startDate} \n ${endDate}`,
          _rowVariant: isFilteredRoute ? 'secondary' : '',
        };
      });
    },
    operationItems() {
      return this.operations.map((o) => {
        const startDate = o.relation ? moment(o.relation.startOperationDate).format('DD/MM - HH:mm [hrs.]') : '-';
        const endDate = o.relation ? moment(o.relation.endOperationDate).format('DD/MM - HH:mm [hrs.]') : '-';
        console.log(o.relation.idState);
        return {
          ...o,
          state: o.relation ? o.relation.idState : 'NOTENDED',
          executionSpot: o.spot ? `${o.spot.address.street}, ${o.spot.address.state}` : '-',
          executionDate: `${startDate} \n ${endDate}`,
        };
      });
    },
    documentItems() {
      return this.documents.map((d) => {
        return {
          ...d,
          route: '-',
          trip: '-',
          activity: '-',
          documentNumber: d.number,
          type: this.documentService.getType(d.type) ? this.documentService.getType(d.type).value : '-',
          items: d.items ? d.items.length : 0,
          time: d.time || 0,
        };
      });
    },
    itemDetailsItems() {
      return this.items.map((i) => {
        return {
          ...i,
          document: i.idDocument,
          type: this.getTypeItem(i.idItemData),
          code: this.getCodeItem(i.idItemData),
          unitMeasure: i.unitMeasure || '-',
          quantity: i.quantity || '-',
          extra1: i.extra1 || '-',
          extra2: i.extra2 || '-',
          extra3: i.extra3 || '-',
          extra4: i.extra4 || '-',
          extra5: i.extra5 || '-',
        };
      });
    },
    planificationFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'id',
          label: this.$t('planification.table.planification.id'),
          ...common,
        },
        {
          key: 'name',
          label: this.$t('planification.table.planification.name'),
          ...common,
        },
        {
          key: 'state',
          label: this.$t('planification.table.planification.state'),
          ...common,
        },
        {
          key: 'totalRoutes',
          label: this.$t('planification.table.planification.totalRoutes'),
          ...common,
        },
        {
          key: 'totalOperationsOptimized',
          label: this.$t('planification.table.planification.totalOperations'),
          ...common,
        },
        {
          key: 'executionDate',
          label: this.$t('planification.table.planification.executionDate'),
          ...common,
        },
        {
          key: 'modifiedAt',
          label: this.$t('planification.table.planification.modifiedAt'),
          ...common,
        },
        {
          key: 'userNameModified',
          label: this.$t('planification.table.planification.userModifiedAt'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('planification.table.planification.actions'),
          ...common,
        },
      ];
    },
    routeFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'id',
          label: this.$t('planification.table.route.id'),
          ...common,
        },
        {
          key: 'name',
          label: this.$t('planification.table.route.name'),
          ...common,
        },
        {
          key: 'state',
          label: this.$t('planification.table.route.state'),
          ...common,
        },
        {
          key: 'driver',
          label: this.$t('planification.table.route.driver'),
          ...common,
        },
        {
          key: 'vehicle',
          label: this.$t('planification.table.route.vehicle'),
          ...common,
        },
        {
          key: 'executionDate',
          label: this.$t('planification.table.route.executionDate'),
          ...common,
        },
        {
          key: 'origin',
          label: this.$t('planification.table.route.origin'),
          ...common,
        },
        {
          key: 'destination',
          label: this.$t('planification.table.route.destination'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('planification.table.planification.actions'),
          ...common,
        },
      ];
    },
    operationFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'id',
          label: this.$t('planification.table.operation.id'),
          ...common,
        },
        {
          key: 'name',
          label: this.$t('planification.table.operation.name'),
          ...common,
        },
        {
          key: 'state',
          label: this.$t('planification.table.operation.state'),
          ...common,
        },
        {
          key: 'type',
          label: this.$t('planification.table.operation.type'),
          ...common,
        },
        {
          key: 'executionDate',
          label: this.$t('planification.table.operation.executionDate'),
          ...common,
        },
        {
          key: 'executionSpot',
          label: this.$t('planification.table.operation.executionSpot'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('planification.table.planification.actions'),
          ...common,
        },
      ];
    },

    documentFields() {
      const baseCell = {
        class: 'text-center',
        tdClass: 'small',
        sortable: false,
      };
      return documentTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        ...baseCell,
      }));
    },
    itemDetailsFields() {
      const baseCell = {
        class: 'text-center',
        tdClass: 'small',
        sortable: false,
      };
      return itemTableSchema.map((e) => ({
        ...e,
        label:
          e.label.split(' ').length > 1
            ? this.$t(e.label.split(' ')[0]) + ' ' + e.label.split(' ')[1]
            : this.$t(e.label),
        ...baseCell,
      }));
    },
  },
};
